import { useNavigate } from "react-router-dom";
import { useOrderOnBehalf } from "../hooks/useOrderOnBehalf";
import { useCart } from "../hooks/useCart";

export default function OrderOnBehalfBanner() {
  const { customer, stopOrdering, isOrdering } = useOrderOnBehalf();
  const { clearCart } = useCart();
  const navigate = useNavigate();

  if (!isOrdering || !customer) return null;

  const displayName = customer.companyName
    ? `${customer.firstName} ${customer.lastName} (${customer.companyName})`
    : `${customer.firstName} ${customer.lastName}`;

  return (
    <div className="bg-accent text-white px-4 py-2 flex items-center justify-between">
      <div className="flex items-center gap-2 text-sm">
        <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
        <span>
          Ordering on behalf of <strong>{displayName}</strong>
        </span>
      </div>
      <div className="flex items-center gap-3">
        <button
          onClick={() => navigate("/checkout")}
          className="text-xs bg-white/20 hover:bg-white/30 text-white px-3 py-1 rounded font-medium transition-colors"
        >
          Go to Checkout
        </button>
        <button
          onClick={async () => {
            await clearCart();
            stopOrdering();
          }}
          className="text-xs bg-white/10 hover:bg-white/20 text-white px-3 py-1 rounded font-medium transition-colors"
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
